/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Multi_StoreyInputs */

const cs_enum_multi_storey = /** @type {(inputs: Enum_Multi_StoreyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patrový`)
};

const en_enum_multi_storey = /** @type {(inputs: Enum_Multi_StoreyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-storey`)
};

/**
* | output |
* | --- |
* | "Multi-storey" |
*
* @param {Enum_Multi_StoreyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_multi_storey = /** @type {((inputs?: Enum_Multi_StoreyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Multi_StoreyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_multi_storey(inputs)
	return cs_enum_multi_storey(inputs)
});